export function extractClinicalConsultationsBeneficiaryId(location) {
    const regex = /\/clinicalconsultations\/([^?]+)/;
    const match = location.hash.match(regex);
    if (match) {
        return match[1];
    }
    return null;
}
